let itemList = [{
    itemName: '白/球蛋白比',
    itemJg: '1.77',
    itemDw: 'A/G',
    itemFw: '1.2-2.4'
  },
  {
    itemName: '天门冬氨酸/丙氨酸氨基转移酶',
    itemJg: '68.9',
    itemDw: 'A/G',
    itemFw: '1.2-2.4'
  },
  {
    itemName: '乳酸脱氢酶',
    itemJg: '24.9',
    itemDw: 'A/G',
    itemFw: '1.2-2.4'
  },
  {
    itemName: '白/球蛋白比',
    itemJg: '1.77',
    itemDw: 'A/G',
    itemFw: '1.2-2.4'
  },
  {
    itemName: '天门冬氨酸/丙氨酸氨基转移酶',
    itemJg: '68.9',
    itemDw: 'A/G',
    itemFw: '1.2-2.4'
  },
  {
    itemName: '乳酸脱氢酶',
    itemJg: '24.9',
    itemDw: 'A/G',
    itemFw: '1.2-2.4'
  },
  {
    itemName: '白/球蛋白比',
    itemJg: '1.77',
    itemDw: 'A/G',
    itemFw: '1.2-2.4'
  },
  {
    itemName: '天门冬氨酸/丙氨酸氨基转移酶',
    itemJg: '68.9',
    itemDw: 'A/G',
    itemFw: '1.2-2.4'
  },
  {
    itemName: '乳酸脱氢酶',
    itemJg: '24.9',
    itemDw: 'A/G',
    itemFw: '1.2-2.4'
  },
  {
    itemName: '白/球蛋白比',
    itemJg: '1.77',
    itemDw: 'A/G',
    itemFw: '1.2-2.4'
  },
  {
    itemName: '天门冬氨酸/丙氨酸氨基转移酶',
    itemJg: '68.9',
    itemDw: 'A/G',
    itemFw: '1.2-2.4'
  },
  {
    itemName: '乳酸脱氢酶',
    itemJg: '24.9',
    itemDw: 'A/G',
    itemFw: '1.2-2.4'
  },
  {
    itemName: '白/球蛋白比',
    itemJg: '1.77',
    itemDw: 'A/G',
    itemFw: '1.2-2.4'
  },
  {
    itemName: '天门冬氨酸/丙氨酸氨基转移酶',
    itemJg: '68.9',
    itemDw: 'A/G',
    itemFw: '1.2-2.4'
  },
  {
    itemName: '乳酸脱氢酶',
    itemJg: '24.9',
    itemDw: 'A/G',
    itemFw: '1.2-2.4'
  }
]

let tableData = [{
    orderCode: ['A1B01566566K', 'A1B015665654'],
    orderID: 'A1B01583948BA499C092808',
    orderTime: '2016-05-02 08:26:38',
    name: '孙二毛',
    sex: '男',
    age: 37,
    phone: '13652458711',
    orderStaus: 2,
    idNumber: '320986199205126578',
    order: '上海市普陀区金沙江路 1518 弄'
  },
  {
    orderCode: ['A1B01566566K', 'A1B015665654'],
    orderID: 'A1B01583948BA499C092808',
    orderTime: '2016-05-02 08:26:38',
    name: '赵花花',
    sex: '女',
    age: 23,
    phone: '13652458711',
    orderStaus: 3,
    idNumber: '320986199205126578',
    order: '上海市普陀区金沙江路 1518 弄'
  },
  {
    orderCode: ['A1B01566566K', 'A1B015665654'],
    orderID: 'A1B01583948BA499C092808',
    orderTime: '2016-05-02 08:26:38',
    name: '王小虎',
    sex: '男',
    age: 30,
    phone: '13652458711',
    orderStaus: 1,
    idNumber: '320986199205126578',
    order: '上海市普陀区金沙江路 1518 弄'
  }, {
    orderCode: ['A1B01566566K', 'A1B015665654'],
    orderID: 'A1B01583948BA499C092808',
    orderTime: '2016-05-02 08:26:38',
    name: '刘小帅',
    sex: '男',
    age: 33,
    phone: '13652458711',
    orderStaus: 4,
    idNumber: '320986199205126578',
    order: '上海市普陀区金沙江路 1518 弄'
  },
  {
    orderCode: ['A1B01566566K', 'A1B015665654'],
    orderID: 'A1B01583948BA499C092808',
    orderTime: '2016-05-02 08:26:38',
    name: '孙二毛',
    sex: '男',
    age: 37,
    phone: '13652458711',
    orderStaus: 2,
    idNumber: '320986199205126578',
    order: '上海市普陀区金沙江路 1518 弄'
  },{
    orderCode: ['A1B01566566K', 'A1B015665654'],
    orderID: 'A1B01583948BA499C092808',
    orderTime: '2016-05-02 08:26:38',
    name: '孙二毛',
    sex: '男',
    age: 37,
    phone: '13652458711',
    orderStaus: 2,
    idNumber: '320986199205126578',
    order: '上海市普陀区金沙江路 1518 弄'
  },{
    orderCode: ['A1B01566566K', 'A1B015665654'],
    orderID: 'A1B01583948BA499C092808',
    orderTime: '2016-05-02 08:26:38',
    name: '孙二毛',
    sex: '男',
    age: 37,
    phone: '13652458711',
    orderStaus: 2,
    idNumber: '320986199205126578',
    order: '上海市普陀区金沙江路 1518 弄'
  },{
    orderCode: ['A1B01566566K', 'A1B015665654'],
    orderID: 'A1B01583948BA499C092808',
    orderTime: '2016-05-02 08:26:38',
    name: '孙二毛',
    sex: '男',
    age: 37,
    phone: '13652458711',
    orderStaus: 2,
    idNumber: '320986199205126578',
    order: '上海市普陀区金沙江路 1518 弄'
  },{
    orderCode: ['A1B01566566K', 'A1B015665654'],
    orderID: 'A1B01583948BA499C092808',
    orderTime: '2016-05-02 08:26:38',
    name: '孙二毛',
    sex: '男',
    age: 37,
    phone: '13652458711',
    orderStaus: 2,
    idNumber: '320986199205126578',
    order: '上海市普陀区金沙江路 1518 弄'
  },{
    orderCode: ['A1B01566566K', 'A1B015665654'],
    orderID: 'A1B01583948BA499C092808',
    orderTime: '2016-05-02 08:26:38',
    name: '孙二毛',
    sex: '男',
    age: 37,
    phone: '13652458711',
    orderStaus: 2,
    idNumber: '320986199205126578',
    order: '上海市普陀区金沙江路 1518 弄'
  }
]
export {
  itemList,
  tableData

}